
import {Container} from "@mui/material";
import BuilderControlledPage from "../BuilderControlledPage";
import {useContext} from "react";
import {StylesContext} from "../../providers/StylesProvider";

export default function ContainedBuilderPage() {
    const { navBarHeight } = useContext(StylesContext);

    return (
        <Container style={{paddingTop: navBarHeight }}>
            <BuilderControlledPage/>
        </Container>
    );
}